import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { checkoutUrl } from '../data/copy';
import { trackPixelEvent } from '../utils/metaPixel';
interface CtaButtonProps {
  children: React.ReactNode;
  href?: string;
  size?: 'default' | 'large';
  variant?: 'gold' | 'outline';
  className?: string;
}
const variants = {
  gold: 'bg-yellow-500 text-zinc-950 hover:bg-yellow-200 shadow-lg shadow-yellow-500/20 focus-visible:outline-yellow-500',
  outline: 'border border-yellow-500/50 text-yellow-200 hover:border-yellow-500 hover:bg-yellow-500/10 focus-visible:outline-yellow-500'
};
export function CtaButton({
  children,
  href = checkoutUrl,
  size = 'default',
  variant = 'gold',
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'large' ? 'px-9 py-5 text-[15px]' : 'px-7 py-4 text-[13px] sm:text-sm';
  const handleClick = () => {
    // Solo los botones que van al checkout cuentan como inicio de compra.
    if (href !== checkoutUrl) return;
    trackPixelEvent('InitiateCheckout', {
      content_name: 'Pallavolo 360',
      value: 19,
      currency: 'EUR'
    });
  };
  return <a href={href} onClick={handleClick} className={`group inline-flex items-center justify-center gap-3 rounded-full font-sans font-bold uppercase tracking-[0.12em] transition-[background-color,border-color,color,transform,box-shadow] duration-150 ease-out hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 active:translate-y-0 ${variants[variant]} ${sizing} ${className}`} data-id="element-41" data-mp="39xzky9d066vw">
      <span data-id="element-42" data-mp="3sw2duz8o8nyz">{children}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" strokeWidth={2.2} aria-hidden="true" data-id="element-43" data-mp="3sv937n6ldebk" />
    </a>;
}